import Axios from 'axios'
import store from '../store'

export default {
  getClientId () {
    return store.getters['Client/clientId']
  },
  sendMail (locationId, roomId, eventId) {
    return Axios.put(`api/public/clients/${this.getClientId()}/locations/${locationId}/rooms/${roomId}/events/${eventId}/release`)
  }
}
